import { IdentificationFormProps } from './types';
import IdentificationFormFieldsV1 from './IdentificationFormFieldsV1';
import IdentificationFormFieldsV2 from './IdentificationFormFieldsV2';
import { IDENTIFICATION_FORM } from '../../config/constants';

const FORM_VERSION = IDENTIFICATION_FORM;
const IdentificationForm = (props: IdentificationFormProps) => {
  if (FORM_VERSION === 'v1') {
    return <IdentificationFormFieldsV1 {...props} />;
  }
  if (FORM_VERSION === 'v2') {
    return <IdentificationFormFieldsV2 {...props} />;
  }
  return <></>;
};

export default IdentificationForm;
